import { parseDate } from "@lyfegen-platform/utils";
import { format, isSameDay, sub } from "date-fns";
import { TFunction } from "i18next";
import { localeDate } from "../../utils/locale-date";
import startUpper from "../../utils/start-upper";

/**
 * @param: dateString should be a valid ISO date string or timestamp
 * @param: t
 */
export default (dateString: string | number, t: TFunction, is24hFormat: boolean = false) => {
	if (!dateString) return "";
	const now = new Date();
	const yesterday = sub(now, { days: 1 });
	const date = parseDate(dateString);

	if (is24hFormat) {
		return formatTo24(date, yesterday, now, t);
	}

	return formatTo12(date, yesterday, now, t);
};

function formatTo12(date: Date, yesterday: Date, now: Date, t: TFunction) {
	if (isSameDay(date, now)) {
		return format(date, `'${startUpper(t("today"))}', 'at' hh:mm aaa`);
	}
	if (isSameDay(date, yesterday)) {
		return format(date, `'${startUpper(t("yesterday"))}', 'at' hh:mm aaa`);
	}

	return localeDate(date, { timeFormat: true });
}

function formatTo24(date: Date, yesterday: Date, now: Date, t: TFunction) {
	if (isSameDay(date, now)) {
		return format(date, `'${startUpper(t("today"))}' HH:mm`);
	}
	if (isSameDay(date, yesterday)) {
		return format(date, `'${startUpper(t("yesterday"))}' HH:mm`);
	}

	return format(date, `yyyy-MM-dd HH:mm`);
}
